import React from 'react';
import { Drawer } from 'antd';
import { SIDE_NAV_PROPERTY, SIDE_NAV_TRANSITION_CURVE } from '../hooks/useSideNavExpanded';

type Props = {
  open: boolean;
  style?: React.CSSProperties;
  bodyStyle?: React.CSSProperties;
  children: React.ReactNode;
};

const ActionBar = ({ open = false, style = {}, bodyStyle = {}, children }: Props) => (
  <Drawer
    placement="bottom"
    closable={false}
    mask={false}
    open={open}
    height="52px"
    style={{
      position: 'fixed',
      left: `var(${SIDE_NAV_PROPERTY})`,
      transition: `left ${SIDE_NAV_TRANSITION_CURVE}`,
      ...style,
    }}
    bodyStyle={{ padding: '11px', background: '#545A6A', ...bodyStyle }}
    getContainer={false}
    destroyOnClose
  >
    {children}
  </Drawer>
);

export default ActionBar;
